import { useMemo } from "react"

import { useParams } from "react-router-dom"

import { GradeBadge } from "@l2r-front/l2r-common"
import { useTranslation } from "@l2r-front/l2r-i18n"
import { WarningAmberRoundedIcon } from "@l2r-front/l2r-icons"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { InfoItemButton } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { RISK_ZONES_DEFAULT_ACTIVE_LAYER } from "../../constants/urlParams"
import { useRiskZonesContext } from "../../contexts/RiskZonesContext"
import { useRiskZoneGrades } from "../../hooks/queries/useRiskZoneGrades"
import { riskZonesLegend } from "../../utils/getRiskZonesConfig"

export const RiskAreasIndicator = (props) => {

    const {
        className,
        ...infoItemProps
    } = props

    const { road } = useParams()
    const { data } = useRiskZoneGrades({
        group_by: "year",
        ...road && { linear_location_road: road },
    })
    const { data: allYearsGrades } = useRiskZoneGrades({ group_by: "year" })

    const [state, dispatch] = useRiskZonesContext()
    const { currentActiveLayer, currentYear } = state
    const { setCurrentActiveLayer } = dispatch
    const { t } = useTranslation(I18N_NAMESPACE)

    const grade = useMemo(() => {
        if (!data || !currentYear) {
            return null
        }
        const currentYearData = data.find(dataItem => {
            return dataItem.year === currentYear
        })
        return currentYearData?.average_grade
    }, [currentYear, data])

    const currentYearHasData = useMemo(() => {
        if (!allYearsGrades || !currentYear) {
            return false
        }
        const currentYearData = allYearsGrades.find(dataItem => {
            return dataItem.year === currentYear
        })
        return !!currentYearData?.average_grade
    }, [currentYear, allYearsGrades])

    return (
        <InfoItemButton
            className={className}
            disabled={!currentYearHasData}
            endAdornments={<GradeBadge
                grade={grade}
                id="riskZones"
                legend={riskZonesLegend}
            />}
            icon={WarningAmberRoundedIcon}
            label={t(I18N_NAMESPACE, "containers.riskAreasIndicator.label")}
            selected={currentActiveLayer === RISK_ZONES_DEFAULT_ACTIVE_LAYER}
            onClick={() => setCurrentActiveLayer(RISK_ZONES_DEFAULT_ACTIVE_LAYER)}
            tooltipText={t(I18N_NAMESPACE, "containers.riskAreasIndicator.tooltip")}
            {...infoItemProps}
        />
    )
}

RiskAreasIndicator.propTypes = InfoItemButton.propTypes & {
    className: PropTypes.string,
}